import { AbilityBuilder, createMongoAbility } from "@casl/ability";
import { createContextualCan } from "@casl/react";
import { createContext } from "react";

export const AbilityContext = createContext({});
export const Can = createContextualCan(AbilityContext.Consumer);

const freePlanPermissions = [
  {
    action: "create",
    subject: "Project",
    conditions: {
      type: {
        $in: ["AR_CARD", "PRODUCT_VISUALIZER"],
      },
    },
  },
  {
    action: "update",
    subject: "Project",
    conditions: {
      type: {
        $in: ["AR_CARD", "PRODUCT_VISUALIZER"],
      },
    },
  },
];

const proPlanPermissions = [
  {
    action: "create",
    subject: "Project",
    conditions: {
      type: {
        $in: ["AR_CARD", "PRODUCT_VISUALIZER", "ECOMMERCE"],
      },
    },
  },
];

const enterprise = {
  name: "Enterprise Plan",
  pricing: {
    monthly: "99 USD",
    yearly: "12 USD",
  },
  permissions: [
    {
      action: "create",
      subject: "Project",
      conditions: {
        type: {
          $in: ["AR_CARD", "PRODUCT_VISUALIZER", "ECOMMERCE"],
        },
      },
    },
    {
      action: "update",
      subject: "Project",
      conditions: {
        type: {
          $in: ["AR_CARD", "PRODUCT_VISUALIZER", "ECOMMERCE"],
        },
      },
    },
    {
      action: "update",
      subject: "Project",
      field: "whiteLabel",
      conditions: {
        type: {
          $in: ["AR_CARD", "PRODUCT_VISUALIZER", "ECOMMERCE"],
        },
      },
    },
  ],
};

export function updateAbility(ability, user) {
  const {
    can: allow,
    cannot: forbid,
    rules,
  } = new AbilityBuilder(createMongoAbility);

  const { admin, plan, currentUsages } = user;
  if (admin?.role === "SUPER_ADMIN") {
    allow("manage", "all");
  } else {
    if (!plan) {
      forbid("read", "all");
      return;
    }
    allow("read", "all");
    if (plan.name === "Free Plan") {
      freePlanPermissions.forEach(({ action, subject, fields, conditions }) => {
        allow(action, subject, fields, conditions);
      });
      forbid("update", "Project", ["variants"]);
    } else if (plan.name === "Pro Plan") {
      proPlanPermissions.forEach(({ action, subject, conditions }) => {
        allow(action, subject, conditions);
      });
      forbid("update", "Project", ["variants"]);
    } else if (plan.name === "Enterprise Plan") {
      enterprisePlanPermissions.forEach(
        ({ action, subject, conditions, fields }) => {
          allow(action, subject, fields, conditions);
        }
      );
    }
  }
  ability.update(rules);
  // relevantRuleFor
}

// features list
// BE
// FE

// Plan, planLimits: list of features

// Standard Plans

// Periods: Monthly, Yearly

// Can.js

export const features = (currentPlan, currentUsage) => ({
  whiteLabel: {
    name: "",
    description: "",
    pricingTable: true,
    featureComparison: false,
    displayOrder: 1,
    type: "boolan" | "number",
    allow: () => {
      return currentPlan.whiteLabel
    }
  },
  variants: {
    name: "",
    description: "",
    allow: () => {
      return currentPlan.whiteLabel
    }
  },
  usageReports: {
    allow: () => {
    return currentPlan.usageReports 
    }
  },
  projectsCount: {
    allow: () => {
      return currentPlan.projectsCount > currentUsage.projectsCount
    }
  },
});



// can(action, subject, fields, conditions);

const plan1 = {
  name: "Free Plan",
  pricing: {},
  features: [
    {
      name: "featureKey",
      value: "true/false/number",
    },
    {
      name: "projectCount",
      value: 100,
    },
  ],
};

// Admin
// All Plans (standard plans vs custom plans)
// User Plans

// currentUser. plan and planLimits, Role

//  fill the ability table

// useFeature, (ability) => hasFeature

// Plans Page
//... User Plan
//... Custom Plan
